module.exports = __webpack_public_path__ + "files/551b75010dec2baaae15a85386331136.png";